<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" style="position: fixed;width: 750px;" primary-title>
                    <v-flex>Update Forum</v-flex> 
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>    
                </v-card-title>
                <v-card-text style="padding-top: 105px;">
                    <v-flex wrap>                
                        <v-flex >
                           <span style="font-size: 15px;font-weight: 600;"> Course Title : </span> 
                           <span style="font-size: 15px;"> {{ Course_Forum.Course_Title }} </span>
                        </v-flex>
                    </v-flex>
                    <v-flex wrap>                
                        <v-flex >
                           <span style="font-size: 15px;font-weight: 600;"> Question : </span> 
                           <span style="font-size: 15px;"> {{ Course_Forum.Question }} </span>
                        </v-flex>
                    </v-flex>
                    <v-flex wrap style="height: 286px;overflow-y: auto;">
                            <div v-for="(item,index) in Course_Forum.Conversation" v-bind:key="index">
                            <div v-if="item.User_Type == 'admin'" class="clsForTicketAdmin">
                                        {{item.Query}}
                            </div>
                            <div v-else class="clsForTicketUser">
                                    {{item.Query}}
                            </div>
                        </div>
                    </v-flex>
                    <v-flex style="padding-top: 15px;">
                        <v-textarea rows='2' no-resize style="padding: 0px;" v-model="Query" label="Forum Reply"></v-textarea>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-flex>
                        <v-btn style="float:right;" color='primary' @click="UpdateForum">Submit Answer</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Course_Forum            : {},
            Query                   : ""
        }
    },
    methods:{
        CloseDialog(){

            this.Course_Forum      = {}
            this.Query  = ''
            this.$emit('close')
        },
        GetForumDetails(Forum){

            let data = {}
            data["Forum_Id"] = Forum["_id"]
            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseforum/findcourseforum`,data)
                        .then(response =>{
                            
                            this.Course_Forum = response["data"]["response"][0]     
                            this.$store.commit("UpdateIndividualFourm", response["data"]["response"][0]);    
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        UpdateForum(){


            let data = {}
            data["Forum_Id"]  = this.Course_Forum['_id']
            data['User_Type']  = 'admin'
            data['Query']      = this.Query
            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseforum/updatecourseforum`,data)
                        .then(response =>{
                                
                            this.$store.commit("UpdateIndividualFourm", response["data"]["response"][0]);    
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        }
    }
}
</script>
<style scoped>
 #editor{
     height: 350px;
 }
  .clsForTicketAdmin{
    margin: 10px 8px;
    padding: 18px 12px;
    text-align: right;
    background: #31356c;
    color: white;
    word-wrap: break-word;
 }
  .clsForTicketUser{
    margin: 10px 8px;
    padding: 18px 12px;
    text-align: left;
    color: black;
    word-wrap: break-word;
    border: 1px solid lightgray;
 }
</style>